// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ApiRunner Component Styles - Performance Optimized */
/* Removed expensive backdrop-filter effects and complex animations */
/* Used CSS containment and will-change for better performance */

.api-runner-page {
    padding: 16px;
    background: linear-gradient(135deg, #f0f2f5 0%, #e8ecf1 50%, #f0f2f5 100%);
    min-height: 100vh;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    position: relative;
    contain: layout style;
}

.api-runner-page::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
        radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.03) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.03) 0%, transparent 50%);
    pointer-events: none;
    will-change: opacity;
}

.page-title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 16px;
    color: #1a202c;
    text-align: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: relative;
}

/* Main Container with Panes */
.api-runner-container {
    display: flex;
    gap: 20px;
    margin-bottom: 16px;
}

.pane {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    flex: 1 1;
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border: 1px solid rgba(255, 255, 255, 0.2);
    position: relative;
    overflow: hidden;
    will-change: transform;
}

.pane::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
    opacity: 0;
    transition: opacity 0.2s ease;
    will-change: opacity;
}

.pane:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.pane:hover::before {
    opacity: 1;
}

.request-pane {
    min-width: 50%;
}

.response-pane {
    min-height: 400px;
    display: flex;
    flex-direction: column;
    overflow-x: auto;
    position: relative;
}

.response-pane::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
    pointer-events: none;
    z-index: 1;
}

.response-title-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%);
    border-bottom: 1px solid rgba(226, 232, 240, 0.6);
    position: relative;
    z-index: 2;
}

.response-title-bar::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
    opacity: 0.7;
}

.response-summary {
    display: flex;
    gap: 20px;
    font-size: 0.95em;
    font-weight: 500;
}

.response-summary .success-count {
    color: #48bb78;
    background: linear-gradient(135deg, #48bb78, #38a169);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 600;
}

.response-summary .failed-count {
    color: #e53e3e;
    background: linear-gradient(135deg, #e53e3e, #c53030);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 600;
}

.pane-title {
    font-size: 18px;
    font-weight: 600;
    padding: 12px;
    border-bottom: 1px solid #e2e8f0;
    margin: 0;
    color: #2d3748;
}

/* URL Bar */
.url-bar {
    display: flex;
    padding: 16px;
    background: linear-gradient(135deg, rgba(247, 250, 252, 0.8) 0%, rgba(237, 242, 247, 0.8) 100%);
    border-bottom: 1px solid rgba(226, 232, 240, 0.5);
    position: relative;
}

.url-bar::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
    pointer-events: none;
}

.method-dropdown {
    padding: 12px 16px;
    border-radius: 8px 0 0 8px;
    border: 1px solid rgba(203, 213, 224, 0.6);
    background: linear-gradient(135deg, #edf2f7 0%, #e2e8f0 100%);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 1;
}

.method-dropdown:hover {
    background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e0 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.url-input {
    flex-grow: 1;
    border: none;
    padding: 12px 16px;
    font-size: 14px;
    background-color: transparent;
    color: #2d3748;
    outline: none;
    transition: all 0.3s ease;
}

.url-input:focus {
    background: rgba(255, 255, 255, 0.8);
    box-shadow: inset 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.url-input-container {
    display: flex;
    align-items: center;
    flex-grow: 1;
    border: 1px solid rgba(203, 213, 224, 0.6);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.8);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.url-input-container:focus-within {
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.url-prefix {
    padding: 12px 16px;
    background: linear-gradient(135deg, rgba(237, 242, 247, 0.9) 0%, rgba(226, 232, 240, 0.9) 100%);
    color: #4a5568;
    border-right: 1px solid rgba(203, 213, 224, 0.6);
    white-space: nowrap;
    font-weight: 500;
}

.url-prefix-select {
    padding: 12px 16px;
    background: linear-gradient(135deg, rgba(237, 242, 247, 0.9) 0%, rgba(226, 232, 240, 0.9) 100%);
    color: #4a5568;
    border: none;
    border-right: 1px solid rgba(203, 213, 224, 0.6);
    white-space: nowrap;
    font-weight: 500;
    cursor: pointer;
    outline: none;
}

.send-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border-radius: 8px;
    border: none;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    cursor: pointer;
    font-weight: 600;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
    position: relative;
    overflow: hidden;
    margin-left: 12px;
    will-change: transform;
}

.send-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
}

.send-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.send-button:hover::before {
    left: 100%;
}

.send-button:active {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(102, 126, 234, 0.2);
}

.send-button:disabled {
    background: linear-gradient(135deg, #a0aec0 0%, #718096 100%);
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 2px 8px rgba(160, 174, 192, 0.2);
}

.reset-link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    color: #e53e3e;
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    transition: all 0.2s ease;
    border-radius: 8px;
    margin-left: auto;
    margin-top: 10px;
}

.reset-link:hover {
    color: #dc2626;
    background-color: rgba(229, 62, 62, 0.1);
    text-decoration: underline;
}

.reset-link:active {
    color: #b91c1c;
}

/* Tabs */
.details-tabs {
    display: flex;
    border-bottom: 1px solid rgba(226, 232, 240, 0.5);
    padding: 0 16px;
    background: linear-gradient(135deg, rgba(253, 253, 255, 0.8) 0%, rgba(248, 250, 252, 0.8) 100%);
    backdrop-filter: blur(5px);
    position: relative;
}

.details-tabs::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.3), transparent);
}

.details-tabs button {
    padding: 12px 18px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #4a5568;
    position: relative;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 6px 6px 0 0;
    margin-bottom: -1px;
}

.details-tabs button:hover {
    color: #667eea;
    background: rgba(102, 126, 234, 0.05);
    transform: translateY(-1px);
}

.details-tabs button.active {
    font-weight: 600;
    color: #667eea;
    background: rgba(102, 126, 234, 0.1);
}

.details-tabs button.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 3px;
    background: linear-gradient(90deg, #667eea, #764ba2);
    border-radius: 2px 2px 0 0;
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    from {
        width: 0;
        opacity: 0;
    }
    to {
        width: 60%;
        opacity: 1;
    }
}

/* Content of Tabs */
.details-content {
    padding: 16px;
    flex-grow: 1;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(5px);
    border-radius: 0 0 16px 16px;
}

.key-value-editor {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.key-value-pair {
    display: flex;
    gap: 10px;
    align-items: center;
}

.key-value-pair input {
    flex: 1 1;
    padding: 8px 10px;
    border: 1px solid #cbd5e0;
    border-radius: 4px;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.key-value-pair input:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 1px #3182ce;
}

.key-value-pair button.remove-btn {
    background: none;
    border: none;
    color: var(--text-color-secondary);
    cursor: pointer;
    padding: 5px;
}

.remove-btn {
    background: none;
    border: none;
    color: #718096;
    cursor: pointer;
    padding: 4px;
    border-radius: 50%;
    transition: color 0.2s, background-color 0.2s;
}
.remove-btn:hover {
    color: #e53e3e;
    background-color: #fed7d7;
}

.readonly-placeholder {
    width: 36px; /* Same as remove button to keep alignment */
}

.response-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%);
    backdrop-filter: blur(5px);
    border-radius: 8px;
    margin-bottom: 8px;
    border: 1px solid rgba(226, 232, 240, 0.6);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
}

.response-header:hover {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.response-header .response-row {
    font-weight: 600;
    color: #2d3748;
    background: linear-gradient(135deg, #667eea, #764ba2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.response-header .response-time {
    font-size: 0.85em;
    color: #718096;
    font-weight: 500;
    background: rgba(113, 128, 150, 0.1);
    padding: 2px 8px;
    border-radius: 12px;
}

.response-header .response-message {
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 0.8em;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
}

.response-header .response-message::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
}

.single-response-container .response-meta {
    padding: 5px 15px;
    display: flex;
    gap: 15px;
    font-size: 0.9em;
    background-color: #2a2a2a;
    border-bottom: 1px solid #333;
}

.multi-response-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.response-meta {
    display: flex;
    gap: 20px;
    font-size: 0.95em;
    font-weight: 500;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.8) 100%);
    backdrop-filter: blur(5px);
    border-radius: 8px;
    border: 1px solid rgba(203, 213, 224, 0.4);
}

.status-code {
    padding: 4px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 0.85em;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
}

.status-code::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
}

.status-code.success {
    background: linear-gradient(135deg, #48bb78, #38a169);
    color: white;
    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
}

.status-code.success:hover::before {
    left: 100%;
}

.status-code.error {
    background: linear-gradient(135deg, #e53e3e, #c53030);
    color: white;
    box-shadow: 0 4px 12px rgba(229, 62, 62, 0.3);
}

.status-code.error:hover::before {
    left: 100%;
}

.execution-time {
    color: #667eea;
    font-weight: 600;
    background: linear-gradient(135deg, #667eea, #764ba2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;
}

.execution-time::after {
    content: '⚡';
    margin-left: 4px;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.7;
        transform: scale(1.1);
    }
}

.time-taken {
    color: #00aaff;
}

.add-btn {
    align-self: flex-start;
    margin-top: 8px;
    padding: 8px 14px;
    border: 1px solid #3182ce;
    color: #3182ce;
    background: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.2s, color 0.2s;
}

.add-btn:hover {
    background-color: #3182ce;
    color: white;
}

.header-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
}

.sync-org-checkbox {
    display: flex;
    align-items: center;
    gap: 6px;
}

.sync-org-checkbox label {
    font-size: 14px;
    color: #4a5568;
    cursor: pointer;
}

.body-input {
    width: 100%;
    min-height: 450px;
    padding: 10px;
    border: 1px solid #3d3d3d;
    border-radius: 4px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 12px;
    background-color: #1e1e1e;
    color: #d4d4d4;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.body-input:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 1px #3182ce;
    background-color: #1e1e1e;
}

.auth-section {
    padding: 20px;
    text-align: center;
}

.auth-token-input {
    width: 100%;
    padding: 10px;
    border: 1px solid #cbd5e0;
    border-radius: 4px;
    font-size: 14px;
}

/* Response Pane */
.response-content {
    padding: 20px;
    flex-grow: 1;
    position: relative;
    overflow-y: auto;
    background: linear-gradient(135deg, rgba(247, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.8) 100%);
    max-height: 600px;
    border-radius: 0 0 16px 16px;
    position: relative;
    z-index: 2;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    font-size: 16px;
    color: #4a5568;
    z-index: 10;
    border-radius: 16px;
}

.loader {
    border: 4px solid rgba(243, 243, 243, 0.8);
    border-top: 4px solid #667eea;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
    50% {
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }
    100% {
        transform: rotate(360deg);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
}

.response-body, .error-response {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%);
    padding: 20px;
    border-radius: 16px;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', Courier, monospace;
    font-size: 13px;
    border: 1px solid rgba(203, 213, 224, 0.4);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    position: relative;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    margin-bottom: 16px;
    will-change: transform;
}

.response-body:hover, .error-response:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.response-body::before, .error-response::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.response-body::before {
    background: linear-gradient(90deg, #48bb78, #38a169, #2f855a);
    box-shadow: 0 0 20px rgba(72, 187, 120, 0.3);
}

.error-response {
    color: #c53030;
    background: linear-gradient(135deg, rgba(254, 215, 215, 0.95) 0%, rgba(254, 202, 202, 0.95) 100%);
    border-color: rgba(245, 101, 101, 0.4);
}

.error-response::before {
    background: linear-gradient(90deg, #e53e3e, #c53030, #9b2c2c);
    box-shadow: 0 0 20px rgba(229, 62, 62, 0.3);
}

.no-response {
    color: #718096;
    text-align: center;
    padding: 80px 40px;
    font-style: italic;
    font-size: 18px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.8) 0%, rgba(248, 250, 252, 0.8) 100%);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    margin: 20px 0;
    border: 2px dashed rgba(113, 128, 150, 0.3);
    position: relative;
    transition: all 0.3s ease;
}

.no-response:hover {
    border-color: rgba(102, 126, 234, 0.5);
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%);
    transform: scale(1.02);
}

.multi-response-item {
    background: rgba(255, 255, 255, 0.8);
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 12px;
    border: 1px solid rgba(226, 232, 240, 0.6);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    position: relative;
    overflow: hidden;
    will-change: transform;
}

.multi-response-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background: linear-gradient(180deg, #667eea, #764ba2);
    opacity: 0;
    transition: opacity 0.2s ease;
}

.multi-response-item:hover {
    transform: translateX(2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.multi-response-item:hover::before {
    opacity: 1;
}

.multi-response-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(226, 232, 240, 0.5);
}

.status-indicator {
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
}

.status-indicator::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
}

.status-indicator.success {
    background: linear-gradient(135deg, #48bb78, #38a169);
    color: white;
    box-shadow: 0 2px 8px rgba(72, 187, 120, 0.3);
}

.status-indicator.success:hover::before {
    left: 100%;
}

.status-indicator.failed {
    background: linear-gradient(135deg, #e53e3e, #c53030);
    color: white;
    box-shadow: 0 2px 8px rgba(229, 62, 62, 0.3);
}

.status-indicator.failed:hover::before {
    left: 100%;
}

/* Fancy Response Animations - Performance Optimized */
/* Using simple transforms and reduced animation complexity */
.response-item {
    animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.response-body.expanded, .error-response.expanded {
    animation: expandIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes expandIn {
    from {
        opacity: 0;
        transform: scale(0.95);
        max-height: 0;
    }
    to {
        opacity: 1;
        transform: scale(1);
        max-height: 1000px;
    }
}

/* Fancy Scrollbar for Response Content */
.response-content::-webkit-scrollbar {
    width: 8px;
}

.response-content::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
}

.response-content::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #667eea, #764ba2);
    border-radius: 4px;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}

.response-content::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #5a67d8, #6b46c1);
}

.row-number {
    font-weight: 600;
    color: #2d3748;
}

.response-status {
    font-size: 13px;
    color: #4a5568;
    background-color: #edf2f7;
    padding: 2px 6px;
    border-radius: 4px;
}

.response-time {
    font-size: 13px;
    color: #718096;
    margin-left: auto;
}

.multi-response-item:last-child {
    border-bottom: none;
}

/* Bottom Section */
.bottom-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.options-card {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%);
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border: 1px solid rgba(255, 255, 255, 0.2);
    position: relative;
    overflow: hidden;
    will-change: transform;
}

.options-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
    opacity: 0;
    transition: opacity 0.2s ease;
}

.options-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.options-card:hover::before {
    opacity: 1;
}

.options-card h3 {
    margin-top: 0;
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #2d3748;
    font-weight: 600;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.options-card p {
    color: #4a5568;
    font-size: 14px;
    line-height: 1.5;
}

.options-card input[type="file"] {
    margin-top: 12px;
    font-size: 14px;
    padding: 8px 12px;
    border: 1px solid rgba(203, 213, 224, 0.6);
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.8);
    transition: all 0.3s ease;
}

.options-card input[type="file"]:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    outline: none;
}

.file-input-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
}

.clear-file-btn {
    padding: 4px 10px;
    border: 1px solid #e53e3e;
    color: #e53e3e;
    background: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.2s, color 0.2s;
}

.clear-file-btn:hover {
    background-color: #e53e3e;
    color: white;
}

/* Batch Progress Indicator */
.batch-progress {
    margin-top: 8px;
    padding: 12px;
    background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.progress-text {
    font-size: 14px;
    font-weight: 600;
    color: #4a5568;
    margin-bottom: 8px;
    text-align: center;
}

.progress-bar {
    width: 100%;
    height: 8px;
    background-color: #e2e8f0;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #48bb78 0%, #38a169 100%);
    border-radius: 4px;
    transition: width 0.3s ease;
    box-shadow: 0 0 4px rgba(72, 187, 120, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/selfService/ApiRunner.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD,qEAAqE;AACrE,gEAAgE;;AAEhE;IACI,aAAa;IACb,0EAA0E;IAC1E,iBAAiB;IACjB,4DAA4D;IAC5D,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;yFAEqF;IACrF,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,0CAA0C;IAC1C,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,qDAAqD;IACrD,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,sEAAsE;IACtE,UAAU;IACV,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gGAAgG;IAChG,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,+FAA+F;IAC/F,iDAAiD;IACjD,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,sEAAsE;IACtE,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,aAAa;IACb,+FAA+F;IAC/F,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gGAAgG;IAChG,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,0CAA0C;IAC1C,6DAA6D;IAC7D,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,oCAAoC;IACpC,wDAAwD;IACxD,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,+FAA+F;IAC/F,cAAc;IACd,gDAAgD;IAChD,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,+FAA+F;IAC/F,cAAc;IACd,YAAY;IACZ,gDAAgD;IAChD,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,6DAA6D;IAC7D,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,qDAAqD;IACrD,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,iDAAiD;IACjD,eAAe;IACf,+FAA+F;IAC/F,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,sFAAsF;AAC1F;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iDAAiD;IACjD,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,oDAAoD;IACpD,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;IACd;IACA;QACI,UAAU;QACV,UAAU;IACd;AACJ;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,YAAY;IACZ,oCAAoC;IACpC,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,6CAA6C;AACjD;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW,EAAE,4CAA4C;AAC7D;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,+FAA+F;IAC/F,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;IACI,iGAAiG;IACjG,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,+FAA+F;IAC/F,0BAA0B;IAC1B,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,0BAA0B;AAC9B;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,qBAAqB;IACzB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,8CAA8C;IAC9C,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,+FAA+F;IAC/F,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,+CAA+C;AACnD;;AAEA;IACI;QACI,uBAAuB;QACvB,+CAA+C;IACnD;IACA;QACI,+CAA+C;IACnD;IACA;QACI,yBAAyB;QACzB,+CAA+C;IACnD;AACJ;;AAEA;IACI,iGAAiG;IACjG,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,6EAA6E;IAC7E,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,kBAAkB;IAClB,qDAAqD;IACrD,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,4BAA4B;IAC5B,wCAAwC;AAC5C;;AAEA;IACI,6DAA6D;IAC7D,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,iGAAiG;IACjG,sCAAsC;AAC1C;;AAEA;IACI,6DAA6D;IAC7D,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,+FAA+F;IAC/F,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,2CAA2C;IAC3C,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,+FAA+F;IAC/F,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,yCAAyC;IACzC,qDAAqD;IACrD,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,qDAAqD;IACrD,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,0BAA0B;AAC9B;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA,sDAAsD;AACtD,6DAA6D;AAC7D;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;QACtB,aAAa;IACjB;IACA;QACI,UAAU;QACV,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA,yCAAyC;AACzC;IACI,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,qDAAqD;IACrD,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,iGAAiG;IACjG,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,qDAAqD;IACrD,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,sEAAsE;IACtE,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gBAAgB;IAChB,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0CAA0C;IAC1C,kBAAkB;IAClB,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,aAAa;IACb,6DAA6D;IAC7D,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,4DAA4D;IAC5D,kBAAkB;IAClB,2BAA2B;IAC3B,2CAA2C;AAC/C","sourcesContent":["/* ApiRunner Component Styles - Performance Optimized */\n/* Removed expensive backdrop-filter effects and complex animations */\n/* Used CSS containment and will-change for better performance */\n\n.api-runner-page {\n    padding: 16px;\n    background: linear-gradient(135deg, #f0f2f5 0%, #e8ecf1 50%, #f0f2f5 100%);\n    min-height: 100vh;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    position: relative;\n    contain: layout style;\n}\n\n.api-runner-page::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background:\n        radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.03) 0%, transparent 50%),\n        radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.03) 0%, transparent 50%);\n    pointer-events: none;\n    will-change: opacity;\n}\n\n.page-title {\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 16px;\n    color: #1a202c;\n    text-align: center;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    position: relative;\n}\n\n/* Main Container with Panes */\n.api-runner-container {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 16px;\n}\n\n.pane {\n    background: rgba(255, 255, 255, 0.95);\n    border-radius: 16px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    position: relative;\n    overflow: hidden;\n    will-change: transform;\n}\n\n.pane::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);\n    opacity: 0;\n    transition: opacity 0.2s ease;\n    will-change: opacity;\n}\n\n.pane:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);\n}\n\n.pane:hover::before {\n    opacity: 1;\n}\n\n.request-pane {\n    min-width: 50%;\n}\n\n.response-pane {\n    min-height: 400px;\n    display: flex;\n    flex-direction: column;\n    overflow-x: auto;\n    position: relative;\n}\n\n.response-pane::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n    pointer-events: none;\n    z-index: 1;\n}\n\n.response-title-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 20px;\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%);\n    border-bottom: 1px solid rgba(226, 232, 240, 0.6);\n    position: relative;\n    z-index: 2;\n}\n\n.response-title-bar::before {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);\n    opacity: 0.7;\n}\n\n.response-summary {\n    display: flex;\n    gap: 20px;\n    font-size: 0.95em;\n    font-weight: 500;\n}\n\n.response-summary .success-count {\n    color: #48bb78;\n    background: linear-gradient(135deg, #48bb78, #38a169);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    font-weight: 600;\n}\n\n.response-summary .failed-count {\n    color: #e53e3e;\n    background: linear-gradient(135deg, #e53e3e, #c53030);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    font-weight: 600;\n}\n\n.pane-title {\n    font-size: 18px;\n    font-weight: 600;\n    padding: 12px;\n    border-bottom: 1px solid #e2e8f0;\n    margin: 0;\n    color: #2d3748;\n}\n\n/* URL Bar */\n.url-bar {\n    display: flex;\n    padding: 16px;\n    background: linear-gradient(135deg, rgba(247, 250, 252, 0.8) 0%, rgba(237, 242, 247, 0.8) 100%);\n    border-bottom: 1px solid rgba(226, 232, 240, 0.5);\n    position: relative;\n}\n\n.url-bar::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n    pointer-events: none;\n}\n\n.method-dropdown {\n    padding: 12px 16px;\n    border-radius: 8px 0 0 8px;\n    border: 1px solid rgba(203, 213, 224, 0.6);\n    background: linear-gradient(135deg, #edf2f7 0%, #e2e8f0 100%);\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    position: relative;\n    z-index: 1;\n}\n\n.method-dropdown:hover {\n    background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e0 100%);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.url-input {\n    flex-grow: 1;\n    border: none;\n    padding: 12px 16px;\n    font-size: 14px;\n    background-color: transparent;\n    color: #2d3748;\n    outline: none;\n    transition: all 0.3s ease;\n}\n\n.url-input:focus {\n    background: rgba(255, 255, 255, 0.8);\n    box-shadow: inset 0 0 0 2px rgba(102, 126, 234, 0.2);\n}\n\n.url-input-container {\n    display: flex;\n    align-items: center;\n    flex-grow: 1;\n    border: 1px solid rgba(203, 213, 224, 0.6);\n    border-radius: 8px;\n    background: rgba(255, 255, 255, 0.8);\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.url-input-container:focus-within {\n    border-color: #667eea;\n    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n}\n\n.url-prefix {\n    padding: 12px 16px;\n    background: linear-gradient(135deg, rgba(237, 242, 247, 0.9) 0%, rgba(226, 232, 240, 0.9) 100%);\n    color: #4a5568;\n    border-right: 1px solid rgba(203, 213, 224, 0.6);\n    white-space: nowrap;\n    font-weight: 500;\n}\n\n.url-prefix-select {\n    padding: 12px 16px;\n    background: linear-gradient(135deg, rgba(237, 242, 247, 0.9) 0%, rgba(226, 232, 240, 0.9) 100%);\n    color: #4a5568;\n    border: none;\n    border-right: 1px solid rgba(203, 213, 224, 0.6);\n    white-space: nowrap;\n    font-weight: 500;\n    cursor: pointer;\n    outline: none;\n}\n\n.send-button {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 20px;\n    border-radius: 8px;\n    border: none;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    cursor: pointer;\n    font-weight: 600;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);\n    position: relative;\n    overflow: hidden;\n    margin-left: 12px;\n    will-change: transform;\n}\n\n.send-button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n    transition: left 0.5s;\n}\n\n.send-button:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.send-button:hover::before {\n    left: 100%;\n}\n\n.send-button:active {\n    transform: translateY(0);\n    box-shadow: 0 1px 4px rgba(102, 126, 234, 0.2);\n}\n\n.send-button:disabled {\n    background: linear-gradient(135deg, #a0aec0 0%, #718096 100%);\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: 0 2px 8px rgba(160, 174, 192, 0.2);\n}\n\n.reset-link {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    color: #e53e3e;\n    text-decoration: none;\n    font-weight: 600;\n    font-size: 16px;\n    transition: all 0.2s ease;\n    border-radius: 8px;\n    margin-left: auto;\n    margin-top: 10px;\n}\n\n.reset-link:hover {\n    color: #dc2626;\n    background-color: rgba(229, 62, 62, 0.1);\n    text-decoration: underline;\n}\n\n.reset-link:active {\n    color: #b91c1c;\n}\n\n/* Tabs */\n.details-tabs {\n    display: flex;\n    border-bottom: 1px solid rgba(226, 232, 240, 0.5);\n    padding: 0 16px;\n    background: linear-gradient(135deg, rgba(253, 253, 255, 0.8) 0%, rgba(248, 250, 252, 0.8) 100%);\n    backdrop-filter: blur(5px);\n    position: relative;\n}\n\n.details-tabs::before {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.3), transparent);\n}\n\n.details-tabs button {\n    padding: 12px 18px;\n    border: none;\n    background: none;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    color: #4a5568;\n    position: relative;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    border-radius: 6px 6px 0 0;\n    margin-bottom: -1px;\n}\n\n.details-tabs button:hover {\n    color: #667eea;\n    background: rgba(102, 126, 234, 0.05);\n    transform: translateY(-1px);\n}\n\n.details-tabs button.active {\n    font-weight: 600;\n    color: #667eea;\n    background: rgba(102, 126, 234, 0.1);\n}\n\n.details-tabs button.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 60%;\n    height: 3px;\n    background: linear-gradient(90deg, #667eea, #764ba2);\n    border-radius: 2px 2px 0 0;\n    animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n    from {\n        width: 0;\n        opacity: 0;\n    }\n    to {\n        width: 60%;\n        opacity: 1;\n    }\n}\n\n/* Content of Tabs */\n.details-content {\n    padding: 16px;\n    flex-grow: 1;\n    background: rgba(255, 255, 255, 0.8);\n    backdrop-filter: blur(5px);\n    border-radius: 0 0 16px 16px;\n}\n\n.key-value-editor {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.key-value-pair {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.key-value-pair input {\n    flex: 1;\n    padding: 8px 10px;\n    border: 1px solid #cbd5e0;\n    border-radius: 4px;\n    transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.key-value-pair input:focus {\n    outline: none;\n    border-color: #3182ce;\n    box-shadow: 0 0 0 1px #3182ce;\n}\n\n.key-value-pair button.remove-btn {\n    background: none;\n    border: none;\n    color: var(--text-color-secondary);\n    cursor: pointer;\n    padding: 5px;\n}\n\n.remove-btn {\n    background: none;\n    border: none;\n    color: #718096;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 50%;\n    transition: color 0.2s, background-color 0.2s;\n}\n.remove-btn:hover {\n    color: #e53e3e;\n    background-color: #fed7d7;\n}\n\n.readonly-placeholder {\n    width: 36px; /* Same as remove button to keep alignment */\n}\n\n.response-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%);\n    backdrop-filter: blur(5px);\n    border-radius: 8px;\n    margin-bottom: 8px;\n    border: 1px solid rgba(226, 232, 240, 0.6);\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n}\n\n.response-header:hover {\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.response-header .response-row {\n    font-weight: 600;\n    color: #2d3748;\n    background: linear-gradient(135deg, #667eea, #764ba2);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.response-header .response-time {\n    font-size: 0.85em;\n    color: #718096;\n    font-weight: 500;\n    background: rgba(113, 128, 150, 0.1);\n    padding: 2px 8px;\n    border-radius: 12px;\n}\n\n.response-header .response-message {\n    font-weight: 600;\n    padding: 4px 12px;\n    border-radius: 16px;\n    font-size: 0.8em;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    position: relative;\n    overflow: hidden;\n}\n\n.response-header .response-message::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n    transition: left 0.6s ease;\n}\n\n.single-response-container .response-meta {\n    padding: 5px 15px;\n    display: flex;\n    gap: 15px;\n    font-size: 0.9em;\n    background-color: #2a2a2a;\n    border-bottom: 1px solid #333;\n}\n\n.multi-response-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.response-meta {\n    display: flex;\n    gap: 20px;\n    font-size: 0.95em;\n    font-weight: 500;\n    margin-bottom: 12px;\n    padding: 12px 16px;\n    background: linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.8) 100%);\n    backdrop-filter: blur(5px);\n    border-radius: 8px;\n    border: 1px solid rgba(203, 213, 224, 0.4);\n}\n\n.status-code {\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-weight: 600;\n    font-size: 0.85em;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    position: relative;\n    overflow: hidden;\n}\n\n.status-code::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n    transition: left 0.6s ease;\n}\n\n.status-code.success {\n    background: linear-gradient(135deg, #48bb78, #38a169);\n    color: white;\n    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);\n}\n\n.status-code.success:hover::before {\n    left: 100%;\n}\n\n.status-code.error {\n    background: linear-gradient(135deg, #e53e3e, #c53030);\n    color: white;\n    box-shadow: 0 4px 12px rgba(229, 62, 62, 0.3);\n}\n\n.status-code.error:hover::before {\n    left: 100%;\n}\n\n.execution-time {\n    color: #667eea;\n    font-weight: 600;\n    background: linear-gradient(135deg, #667eea, #764ba2);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    position: relative;\n}\n\n.execution-time::after {\n    content: '⚡';\n    margin-left: 4px;\n    animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n    0%, 100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n    50% {\n        opacity: 0.7;\n        transform: scale(1.1);\n    }\n}\n\n.time-taken {\n    color: #00aaff;\n}\n\n.add-btn {\n    align-self: flex-start;\n    margin-top: 8px;\n    padding: 8px 14px;\n    border: 1px solid #3182ce;\n    color: #3182ce;\n    background: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: background-color 0.2s, color 0.2s;\n}\n\n.add-btn:hover {\n    background-color: #3182ce;\n    color: white;\n}\n\n.header-controls {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 8px;\n}\n\n.sync-org-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.sync-org-checkbox label {\n    font-size: 14px;\n    color: #4a5568;\n    cursor: pointer;\n}\n\n.body-input {\n    width: 100%;\n    min-height: 450px;\n    padding: 10px;\n    border: 1px solid #3d3d3d;\n    border-radius: 4px;\n    font-family: 'Courier New', Courier, monospace;\n    font-size: 12px;\n    background-color: #1e1e1e;\n    color: #d4d4d4;\n    transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.body-input:focus {\n    outline: none;\n    border-color: #3182ce;\n    box-shadow: 0 0 0 1px #3182ce;\n    background-color: #1e1e1e;\n}\n\n.auth-section {\n    padding: 20px;\n    text-align: center;\n}\n\n.auth-token-input {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #cbd5e0;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n/* Response Pane */\n.response-content {\n    padding: 20px;\n    flex-grow: 1;\n    position: relative;\n    overflow-y: auto;\n    background: linear-gradient(135deg, rgba(247, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.8) 100%);\n    max-height: 600px;\n    border-radius: 0 0 16px 16px;\n    position: relative;\n    z-index: 2;\n}\n\n.loading-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.9);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    font-size: 16px;\n    color: #4a5568;\n    z-index: 10;\n    border-radius: 16px;\n}\n\n.loader {\n    border: 4px solid rgba(243, 243, 243, 0.8);\n    border-top: 4px solid #667eea;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\n    }\n    50% {\n        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n    }\n    100% {\n        transform: rotate(360deg);\n        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\n    }\n}\n\n.response-body, .error-response {\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%);\n    padding: 20px;\n    border-radius: 16px;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', Courier, monospace;\n    font-size: 13px;\n    border: 1px solid rgba(203, 213, 224, 0.4);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n    position: relative;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    margin-bottom: 16px;\n    will-change: transform;\n}\n\n.response-body:hover, .error-response:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n}\n\n.response-body::before, .error-response::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    border-radius: 16px 16px 0 0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.response-body::before {\n    background: linear-gradient(90deg, #48bb78, #38a169, #2f855a);\n    box-shadow: 0 0 20px rgba(72, 187, 120, 0.3);\n}\n\n.error-response {\n    color: #c53030;\n    background: linear-gradient(135deg, rgba(254, 215, 215, 0.95) 0%, rgba(254, 202, 202, 0.95) 100%);\n    border-color: rgba(245, 101, 101, 0.4);\n}\n\n.error-response::before {\n    background: linear-gradient(90deg, #e53e3e, #c53030, #9b2c2c);\n    box-shadow: 0 0 20px rgba(229, 62, 62, 0.3);\n}\n\n.no-response {\n    color: #718096;\n    text-align: center;\n    padding: 80px 40px;\n    font-style: italic;\n    font-size: 18px;\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.8) 0%, rgba(248, 250, 252, 0.8) 100%);\n    backdrop-filter: blur(10px);\n    border-radius: 20px;\n    margin: 20px 0;\n    border: 2px dashed rgba(113, 128, 150, 0.3);\n    position: relative;\n    transition: all 0.3s ease;\n}\n\n.no-response:hover {\n    border-color: rgba(102, 126, 234, 0.5);\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%);\n    transform: scale(1.02);\n}\n\n.multi-response-item {\n    background: rgba(255, 255, 255, 0.8);\n    border-radius: 12px;\n    padding: 16px;\n    margin-bottom: 12px;\n    border: 1px solid rgba(226, 232, 240, 0.6);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    position: relative;\n    overflow: hidden;\n    will-change: transform;\n}\n\n.multi-response-item::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 3px;\n    height: 100%;\n    background: linear-gradient(180deg, #667eea, #764ba2);\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.multi-response-item:hover {\n    transform: translateX(2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n}\n\n.multi-response-item:hover::before {\n    opacity: 1;\n}\n\n.multi-response-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid rgba(226, 232, 240, 0.5);\n}\n\n.status-indicator {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 4px 10px;\n    border-radius: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    position: relative;\n    overflow: hidden;\n}\n\n.status-indicator::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n    transition: left 0.6s ease;\n}\n\n.status-indicator.success {\n    background: linear-gradient(135deg, #48bb78, #38a169);\n    color: white;\n    box-shadow: 0 2px 8px rgba(72, 187, 120, 0.3);\n}\n\n.status-indicator.success:hover::before {\n    left: 100%;\n}\n\n.status-indicator.failed {\n    background: linear-gradient(135deg, #e53e3e, #c53030);\n    color: white;\n    box-shadow: 0 2px 8px rgba(229, 62, 62, 0.3);\n}\n\n.status-indicator.failed:hover::before {\n    left: 100%;\n}\n\n/* Fancy Response Animations - Performance Optimized */\n/* Using simple transforms and reduced animation complexity */\n.response-item {\n    animation: slideInUp 0.5s ease-out;\n}\n\n@keyframes slideInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.response-body.expanded, .error-response.expanded {\n    animation: expandIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes expandIn {\n    from {\n        opacity: 0;\n        transform: scale(0.95);\n        max-height: 0;\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n        max-height: 1000px;\n    }\n}\n\n/* Fancy Scrollbar for Response Content */\n.response-content::-webkit-scrollbar {\n    width: 8px;\n}\n\n.response-content::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 4px;\n}\n\n.response-content::-webkit-scrollbar-thumb {\n    background: linear-gradient(180deg, #667eea, #764ba2);\n    border-radius: 4px;\n    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);\n}\n\n.response-content::-webkit-scrollbar-thumb:hover {\n    background: linear-gradient(180deg, #5a67d8, #6b46c1);\n}\n\n.row-number {\n    font-weight: 600;\n    color: #2d3748;\n}\n\n.response-status {\n    font-size: 13px;\n    color: #4a5568;\n    background-color: #edf2f7;\n    padding: 2px 6px;\n    border-radius: 4px;\n}\n\n.response-time {\n    font-size: 13px;\n    color: #718096;\n    margin-left: auto;\n}\n\n.multi-response-item:last-child {\n    border-bottom: none;\n}\n\n/* Bottom Section */\n.bottom-section {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n}\n\n.options-card {\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%);\n    border-radius: 16px;\n    padding: 20px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    position: relative;\n    overflow: hidden;\n    will-change: transform;\n}\n\n.options-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.options-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n}\n\n.options-card:hover::before {\n    opacity: 1;\n}\n\n.options-card h3 {\n    margin-top: 0;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #2d3748;\n    font-weight: 600;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.options-card p {\n    color: #4a5568;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.options-card input[type=\"file\"] {\n    margin-top: 12px;\n    font-size: 14px;\n    padding: 8px 12px;\n    border: 1px solid rgba(203, 213, 224, 0.6);\n    border-radius: 6px;\n    background: rgba(255, 255, 255, 0.8);\n    transition: all 0.3s ease;\n}\n\n.options-card input[type=\"file\"]:focus {\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n    outline: none;\n}\n\n.file-input-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.clear-file-btn {\n    padding: 4px 10px;\n    border: 1px solid #e53e3e;\n    color: #e53e3e;\n    background: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: background-color 0.2s, color 0.2s;\n}\n\n.clear-file-btn:hover {\n    background-color: #e53e3e;\n    color: white;\n}\n\n/* Batch Progress Indicator */\n.batch-progress {\n    margin-top: 8px;\n    padding: 12px;\n    background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.progress-text {\n    font-size: 14px;\n    font-weight: 600;\n    color: #4a5568;\n    margin-bottom: 8px;\n    text-align: center;\n}\n\n.progress-bar {\n    width: 100%;\n    height: 8px;\n    background-color: #e2e8f0;\n    border-radius: 4px;\n    overflow: hidden;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.progress-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #48bb78 0%, #38a169 100%);\n    border-radius: 4px;\n    transition: width 0.3s ease;\n    box-shadow: 0 0 4px rgba(72, 187, 120, 0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
